const x = {
  x0: "0px",
  x1: "4px",
  x2: "8px",
  x3: "12px",
  x4: "16px",
  x5: "20px",
  x6: "24px",
  x7: "28px",
  x8: "32px",
  x9: "36px",
  x10: "40px",
  x11: "44px",
  x12: "48px",
  x13: "52px",
  x14: "56px",
  x15: "60px"
}, p = {
  x0: "0px",
  x1: "4px",
  x2: "8px",
  x3: "12px",
  x4: "16px",
  x5: "20px",
  x6: "24px",
  x8: "32px",
  x10: "40px"
}, o = {
  mobile: "1023px"
};
export {
  o as breakpoint,
  p as rounded,
  x as size
};
